import React from "react";
// import {WaveBottom} from "../svg";

export default ({page_title = ""}) => (
  <div className="flex flex-center column header pt-l">
    <h1 className="title pb-l">{page_title}</h1>
    {/* <WaveBottom /> */}
  </div>
);
